var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeKlasemenPertandingan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0946 3.61333L27.9821 6.00809L28.4996 30.7743L11.612 28.3795L11.0946 3.61333Z",
    fill: "#578B2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0945 3.65304L24.6095 5.47956L20.2519 11.8754L0.0330181 9.0082L11.0945 3.65304Z",
    fill: "#77B341"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.00352L20.2519 11.8754L20.7264 34.5899L0.474606 31.7181L0 9.00352Z",
    fill: "#89C353"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9325 11.6883L20.2519 11.8754L20.7264 34.5899L19.4071 34.4028L18.9325 11.6883Z",
    fill: "#578B2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7655 0.0201892L49.2152 2.9201L49.8674 34.1343L29.4177 31.2344L28.7655 0.0201892Z",
    fill: "#0397C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7909 0L49.2128 2.89861L39.0419 7.74576L18.7901 4.87391L28.7909 0Z",
    fill: "#01AFE0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7901 4.87391L39.0419 7.74576L39.6589 37.2747L19.4071 34.4028L18.7901 4.87391Z",
    fill: "#00BCF1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4299 17.5108L69 20.6079V34.823L59.8904 39.9849L53.9916 37.7093L49.7927 34.8764L49.4299 17.5108Z",
    fill: "#DA6014"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3995 17.5108L69 20.6476L59.5341 25.2628L39.3482 22.4003L49.3995 17.5108Z",
    fill: "#F48120"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3482 22.4003L59.6 25.2722L59.9078 40L39.6559 37.1281L39.3482 22.4003Z",
    fill: "#FB9743"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68774 24.9016L7.65887 23.5201L10.2071 20.9843C10.7205 20.4792 10.973 20.0242 10.9645 19.6193C10.959 19.3573 10.8806 19.1364 10.7293 18.9567C10.5778 18.7689 10.3725 18.6567 10.1135 18.62C9.59536 18.5465 9.2205 18.7942 8.98886 19.3629L7.47043 18.2096C7.69483 17.6477 8.04064 17.2455 8.50785 17.003C8.97507 16.7606 9.48993 16.6792 10.0524 16.759C10.7778 16.8619 11.4008 17.1916 11.9217 17.7484C12.4497 18.2982 12.7222 18.978 12.7391 19.7879C12.7575 20.6691 12.3724 21.4853 11.5837 22.2363L10.325 23.447L12.934 23.817L12.9723 25.651L7.68774 24.9016Z",
    fill: "#578B2D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9392 12.0057L30.4935 12.2261L30.6677 20.5625L28.8914 20.3106L28.7592 13.9869L27.391 14.1966L26.924 12.5036L28.9392 12.0057Z",
    fill: "#0397C9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6767 30.4841C51.1764 30.737 51.5823 31.0914 51.8944 31.5473C52.2063 31.9953 52.3681 32.4971 52.3797 33.0529C52.3979 33.9262 52.1383 34.5702 51.6009 34.9847C51.0635 35.3993 50.3988 35.5505 49.6069 35.4382C48.9926 35.351 48.438 35.122 47.9432 34.751C47.4558 34.3811 47.0913 33.8861 46.8496 33.2661L48.3617 32.5306C48.5664 33.1454 48.9685 33.4953 49.5681 33.5803C49.9159 33.6297 50.1768 33.5796 50.3508 33.4301C50.5248 33.2806 50.609 33.0709 50.6033 32.801C50.5977 32.531 50.5042 32.2961 50.323 32.0963C50.1417 31.8964 49.8771 31.7718 49.5292 31.7225L49.1629 31.6705L48.463 30.4908L49.8329 28.7733L46.9908 28.3703L46.9535 26.5839L51.9494 27.2924L51.9817 28.8406L50.6767 30.4841Z",
    fill: "#DA6014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeKlasemenPertandingan);
export default __webpack_public_path__ + "static/media/home-klasemen-pertandingan.112f854c13c0c8cf02835690b96b1ee9.svg";
export { ForwardRef as ReactComponent };